import { BookLanguage, Language } from "../../../../rest/models";
import { useAppDispatch } from "../../../../store/hooks";
import { bookEditorActions } from "../slice";
import { BookEditExplanations } from "../explanation";
import { ModelMap } from "../../../../rest/slice";
import { DNDSortableList } from "../../../../dnd/DNDSortableList";

export function LanguageOrderEdit(props: Props)
{
    const appDispatch = useAppDispatch();
    const {book_languages, lang_models} = props;

    function moveBookLanguage(i: number, change: number)
    {
        appDispatch(bookEditorActions.moveBookLanguage([i, i + change]))
    }
    
    function renderItemContents(bl: BookLanguage, i: number)
    {                    
        return (
            <>
                <td>{lang_models[bl.language].name}</td>
                <td onClick={() => moveBookLanguage(i, -1)}>▲</td>
                <td onClick={() => moveBookLanguage(i, 1)}>▼</td>
            </>);
    }

    return (
        <div className='ernots_LanguageOrderEdit'>
            <label>
                Language Display Order
            </label>
            <div children={BookEditExplanations.lang_order}/>
            <table border={1}>
                <thead>
                    <tr>
                        <th>Language</th>
                        <th>▲</th>
                        <th>▼</th>
                    </tr>
                </thead>
                <tbody>
                    <DNDSortableList
                        items={book_languages}
                        itemElementTag="tr"
                        renderItemContents={renderItemContents}
                        moveItem={function(oldIndex, newIndex)
                        {
                            appDispatch(bookEditorActions.moveBookLanguage([oldIndex, newIndex]));
                            if (newIndex > oldIndex)
                            {
                                //The item ends up before the one at newIndex.
                                //If item was moved down, push it down.
                                //Or rather, push the other one up.
                                //appDispatch(bookEditorActions.moveBookLanguage([newIndex, newIndex - 1]));
                            }
                        }}/>
                </tbody>
            </table>
        </div>);
}

interface Props
{
    book_languages: BookLanguage[];
    lang_models: ModelMap<Language>;
}